import { FC } from 'react'
import Swal from 'sweetalert2'
import { GrupoModal } from '../../components/modal/GrupoModal'
import { GrupoPerfisModal } from '../../components/modal/GrupoPerfisModal'
import { deleteGrupo, getGrupoById } from '../../core/_requests'
import { useQueryResponse } from '../../core/QueryResponseProvider'
import { GrupoList } from '../../core/_models'
import { IconPaths, showAlertLoading, showConfirmAlert, showError } from '_metronic/helpers'
import { RowActions, useModal, useToast } from 'app/components'
import { useT } from '_metronic/i18n/Metronici18n'

type Props = {
  grupo: GrupoList
}

export const GruposActionsCell: FC<Props> = ({ grupo }) => {
  const { showModal } = useModal()
  const { showToast } = useToast()
  const { refetch } = useQueryResponse()
  const { t } = useT()
  const nome = grupo.nome || t('grupo.label')

  const openEditModal = () =>
    showModal({
      title: 'Editar Perfil',
      content: <GrupoModal />,
      fetchers: {
        grupo: () => getGrupoById(grupo.id),
      },
    })

  const openPermissoesModal = () =>
    showModal({
      title: t('permissao.plural'),
      content: <GrupoPerfisModal />,
      fetchers: {
        grupo: () => getGrupoById(grupo.id),
      },
    })

  const askDelete = async () => {
    const confirmed = await showConfirmAlert({
      title: 'Excluir perfil?',
      text: `O perfil ${nome} será excluído.`,
      confirmButtonText: 'Excluir',
      cancelButtonText: 'Cancelar',
      danger: true,
    })
    if (!confirmed) return

    try {
      showAlertLoading()
      await deleteGrupo(grupo.id)
      Swal.close()
      showToast({ variant: 'success', title: `O perfil ${nome} foi excluído.` })
      refetch()
    } catch (error) {
      showError(error)
    }
  }

  return (
    <RowActions
      itemName={`perfil ${nome}`}
      primaryAction={{ label: t('common.edit'), onClick: openEditModal, icon: IconPaths.Pen }}
      items={[
        { label: t('permissao.plural'), onClick: openPermissoesModal },
        { label: t('common.delete'), onClick: askDelete, danger: true },
      ]}
    />
  )
}
